module.exports = __webpack_public_path__ + "img/img4-600x498.4c651cc6.jpg";